import { z } from 'zod';
import { NullableJsonValue } from "../inputTypeSchemas/NullableJsonValue"

/////////////////////////////////////////
// CORE MAP FEATURE CUSTOM FIELD VALUE SCHEMA
/////////////////////////////////////////

export const CoreMapFeatureCustomFieldValueSchema = z.object({
  id: z.number().int(),
  cityId: z.number().int(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  valueString: z.string().nullable(),
  valueBoolean: z.boolean().nullable(),
  valueInt: z.number().int().nullable(),
  valueFloat: z.number().nullable(),
  valueDatetime: z.coerce.date().nullable(),
  valueJson: NullableJsonValue.optional(),
  rowTimestamp: z.coerce.date(),
  customFieldId: z.number().int(),
  featureId: z.number().int(),
})

export type CoreMapFeatureCustomFieldValue = z.infer<typeof CoreMapFeatureCustomFieldValueSchema>

export default CoreMapFeatureCustomFieldValueSchema;
